{
  "familyId": "GET-PROC-BASIS",
  "questions": [
    {
      "id": "GET-PROC-BASIS-001",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'een derde'?",
      "context": null,
      "options": [
        "$\\frac{1}{3}$",
        "$\\frac{1}{2}$",
        "$\\frac{1}{4}$",
        "$\\frac{3}{1}$"
      ],
      "correctAnswer": 0,
      "conceptId": "identify_fraction_third",
      "variantIndex": 1,
      "group": 6,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "label": "1 van de 3 gelijke delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "label": "Een derde = $\\frac{1}{3}$: 1 deel van 3 gelijke delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "feedback": {
        "explanationText": "'Een derde' betekent: je verdeelt iets in 3 gelijke stukken en neemt er 1. Het getal boven de streep (1) zegt hoeveel stukken je hebt. Het getal onder de streep (3) zegt in hoeveel gelijke stukken je verdeelt. Dus: 1 van de 3 = $\\frac{1}{3}$.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{3}$ = 1 van de 3 gelijke delen = een derde.",
          "1": "Je dacht waarschijnlijk dat $\\frac{1}{2}$ een derde is. Maar $\\frac{1}{2}$ is een half: je verdeelt in 2 stukken. Bij een derde verdeel je in 3 stukken. Onthoud: het getal onder de streep zegt in hoeveel stukken je verdeelt.",
          "2": "Je dacht waarschijnlijk dat $\\frac{1}{4}$ een derde is. Maar $\\frac{1}{4}$ is een kwart: 1 van de 4 stukken. Een derde heeft het getal 3 onder de streep, niet 4. Onthoud: 'derde' = 3 onder de streep.",
          "3": "Je dacht waarschijnlijk dat $\\frac{3}{1}$ een derde is. Maar $\\frac{3}{1}$ betekent 3 hele — dat is groter dan 1. Een derde is juist kleiner dan 1 heel. Onthoud: bij een derde staat de 1 bóven de streep en de 3 ónder de streep."
        }
      }
    },
    {
      "id": "GET-PROC-BASIS-002",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Welk percentage hoort bij 0,1?",
      "context": null,
      "options": [
        "10%",
        "1%",
        "0,1%",
        "100%"
      ],
      "correctAnswer": 0,
      "conceptId": "decimal_to_percent_tenth",
      "variantIndex": 4,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 10,
            "label": "0,1 = $\\frac{1}{10}$ = 10%",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "feedback": {
        "explanationText": "Kijk naar het getal 0,1. Dit is hetzelfde als $\\frac{1}{10}$. Om een breuk naar procent te zetten, vermenigvuldig je met 100. Bereken: $\\frac{1}{10}$ × 100 = 10%. Dus 0,1 = 10%.",
        "distractorExplanations": {
          "0": "Goed! 0,1 × 100 = 10%.",
          "1": "Je dacht waarschijnlijk dat 0,1 hetzelfde is als 0,01. Maar 0,01 = 1% en 0,1 = 10%. Onthoud: 0,1 is tien keer zo groot als 0,01, dus ook het percentage is tien keer zo groot.",
          "2": "Je dacht waarschijnlijk dat 0,1 al een percentage is. Maar 0,1 is een kommagetal, geen procent. Je moet nog × 100 doen: 0,1 × 100 = 10%. Onthoud: procent betekent 'per honderd', dus je vermenigvuldigt altijd met 100.",
          "3": "Je dacht waarschijnlijk dat 0,1 gelijk is aan 1 heel. Maar 0,1 is slechts een tiende van 1 heel. 100% = 1,0 (het hele getal). Onthoud: 0,1 is tien keer kleiner dan 1, dus het percentage is ook tien keer kleiner: 10%."
        }
      }
    },
    {
      "id": "GET-PROC-BASIS-003",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Hoeveel is 100%?",
      "context": null,
      "options": [
        "het hele bedrag",
        "de helft",
        "een kwart",
        "niets"
      ],
      "correctAnswer": 0,
      "conceptId": "percent_whole",
      "variantIndex": 5,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [],
      "feedback": {
        "explanationText": "100% = het geheel, alles, niets weggelaten. Bereken: 100% van €50 = $\\frac{100}{100}$ × €50 = 1 × €50 = €50 (het hele bedrag). Onthoud: 0% = niets, 50% = de helft, 100% = alles.",
        "distractorExplanations": {
          "0": "Goed! 100% = het hele bedrag, het volledige geheel.",
          "1": "Je dacht waarschijnlijk dat 100% de helft is. Maar de helft is 50%, niet 100%. Bij 50% neem je precies de helft: 50% van €50 = €25. Bij 100% neem je alles: €50. Onthoud: 100% = alles, 50% = de helft.",
          "2": "Je dacht waarschijnlijk dat 100% een kwart is. Maar een kwart is 25%, niet 100%. Bij 25% neem je een vierde deel: 25% van €50 = €12,50. Onthoud: 100% = alles, 25% = een kwart.",
          "3": "Je dacht waarschijnlijk dat 100% niets is. Maar niets is 0% — het tegenovergestelde van 100%. Bij 0% heb je niets, bij 100% heb je juist alles. Onthoud: 0% = niets, 100% = alles."
        }
      }
    },
    {
      "id": "GET-PROC-BASIS-004",
      "familyId": "GET-PROC-BASIS",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "skill": "procenten",
      "subSkill": "proc_breuk_decimaal",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 10%?",
      "context": null,
      "options": [
        "$\\frac{1}{10}$",
        "$\\frac{1}{100}$",
        "$\\frac{10}{1}$",
        "$\\frac{1}{5}$"
      ],
      "correctAnswer": 0,
      "conceptId": "percent_fraction_tenth",
      "variantIndex": 6,
      "group": 6,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 10,
            "label": "10% = 1 van de 10 gelijke delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 10,
            "label": "10% = $\\frac{1}{10}$: 1 deel van 10 gelijke delen",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "feedback": {
        "explanationText": "10% betekent 10 van de 100, dus $\\frac{10}{100}$. Vereenvoudig deze breuk: deel het getal boven de streep en het getal onder de streep allebei door 10. Dan krijg je $\\frac{1}{10}$. Dus 10% = $\\frac{1}{10}$.",
        "distractorExplanations": {
          "0": "Goed! 10% = $\\frac{10}{100}$ = $\\frac{1}{10}$ na vereenvoudigen.",
          "1": "Je dacht waarschijnlijk dat 10% hetzelfde is als $\\frac{1}{100}$. Maar $\\frac{1}{100}$ = 1%, niet 10%. Onthoud: 10% = $\\frac{10}{100}$ = $\\frac{1}{10}$ — het getal onder de streep is 10, niet 100.",
          "2": "Je dacht waarschijnlijk dat $\\frac{10}{1}$ = 10 hele getallen hetzelfde is als 10%. Maar 10% is juist een klein deel (minder dan 1 heel). $\\frac{10}{1}$ = 10 hele — dat is veel meer dan 1. Onthoud: 10% = $\\frac{1}{10}$, een tiende deel.",
          "3": "Je dacht waarschijnlijk dat $\\frac{1}{5}$ = 10%. Maar $\\frac{1}{5}$ × 100 = 20% — dat is twee keer zo groot als 10%. Onthoud: 10% = $\\frac{1}{10}$, niet $\\frac{1}{5}$."
        }
      }
    }
  ]
}